'use strict';
var GEO_DATA, Location, breakDownAddress, findSearchOverridesLink, getFormattedQueryString, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, normalizeQuery, omit, pickByIdentity, redirectToUrl, ref, removeGeolocationData, saveLocationAndRedirect, saveRecentSearch, setSiteCookies, storeGeolocationData, storeLocationData,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Location = require('./m_location_helper');

normalizeQuery = require('./m_normalizeQuery').normalizeQuery;

saveRecentSearch = require('./m_typeahead_helper').saveRecentSearch;

ref = require('../../general/m_underscore_replacements'), omit = ref.omit, pickByIdentity = ref.pickByIdentity;

redirectToUrl = require('../../general/m_setWindowLocation');

setSiteCookies = require('../../general/m_setSiteCookies');


/**
 * @type {Array} GEO_DATA Location attributes to exclude
 */

GEO_DATA = ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code'];


/**
 * Splits address into address components (e.g "Chicago, IL" into "Chicago" and "IL")
 *
 * @param   {Object} data {address}               - Location object
 * @returns {Object} data {address, geoCoderData} - Split address data
 */

breakDownAddress = function(data) {
  var address, extendedData, geocoderData, ref1;
  address = ((data != null ? (ref1 = data.address) != null ? ref1.split(',') : void 0 : void 0) || []).map(function(s) {
    return s.trim();
  });
  data = omit(data, GEO_DATA);
  if (!data.currentLocation) {
    geocoderData = {
      friendlyName: data.address,
      fullAddress: data.address
    };
    extendedData = (function() {
      switch (address.length) {
        case 1:
          return {
            postal_code: address[0]
          };
        case 2:
          return {
            locality: address[0],
            administrative_area: address[1]
          };
        case 3:
          return {
            neighborhood: address[0],
            locality: address[1],
            administrative_area: address[2]
          };
      }
    })();
    geocoderData = Object.assign({}, geocoderData, extendedData);
  }
  data.geocoderData = geocoderData || {};
  return data;
};


/**
 * Returns link if query matches deal override config
 *
 * @param   {String}      query          - User query
 * @param   {Boolean}     [isMobile2016] - Flag indicating mobile2016 (optional)
 * @param   {String}      divisionId     - Division id (optional)
 * @returns {Null|String} link           - Link for matching query
 */

findSearchOverridesLink = function(query, isMobile2016, divisionId) {
  var i, len, link, ref1, ref2, searchOverrides, terms, url;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  searchOverrides = ((ref1 = window.Groupon.LS.data) != null ? ref1.searchOverrides : void 0) || [];
  if (divisionId) {
    url = getGeoSearchOverrideUrl(query, divisionId);
    if (url) {
      return url;
    }
  }
  if ((searchOverrides != null ? searchOverrides.length : void 0) && query) {
    searchOverrides = searchOverrides.filter(function(item) {
      return !item.hasOwnProperty('locations');
    });
    query = query.toLowerCase().trim();
    if (isMobile2016) {
      searchOverrides = searchOverrides.filter(function(item) {
        return item.m2016;
      });
    }
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref2 = searchOverrides[i], link = ref2.link, terms = ref2.terms;
      if (indexOf.call(terms, query) < 0) {
        continue;
      }
      return link;
    }
  }
  return null;
};


/**
 * Get division object if existent
 *
 * @returns {Object} {lat, lng, fullAddress, closestDivision} Returns division object
 */

getLocationForSearch = function() {
  var division;
  if (division = Location.getDivision()) {
    return {
      lat: division.lat,
      lng: division.lng,
      fullAddress: Location.userFriendlyLocation(division),
      closestDivision: division.id
    };
  }
};


/**
 * Parametrizes and picks unique url arguments
 *
 * @param   {Object} params - Url parameter
 * @returns {String}        - Parametrized url arguments
 */

getFormattedQueryString = function(params) {
  if (params == null) {
    params = {};
  }
  params.locale = document.head.getAttribute('data-locale');
  return $.param(pickByIdentity(params)).replace(/\s|%20/g, '+');
};


/**
 * Build PULL url from arguments to complete search submit
 *
 * @param   {String} divisionId - Unique division name
 * @param   {Object} params     - Url parameter
 * @returns {String}
 */

getSearchUrl = function(divisionId, params) {
  var urlParams;
  urlParams = getFormattedQueryString(params);
  return "/browse/" + divisionId + "?" + urlParams;
};


/* *
 */

saveLocationAndRedirect = function(place) {
  var division, fullAddress, lat, lng, locationData;
  lat = place.lat, lng = place.lng, fullAddress = place.fullAddress, division = place.division;
  locationData = Object.assign(place, {
    friendlyName: fullAddress,
    address: fullAddress
  });
  Location.setELLCookie(lat + "," + lng);
  Location.removeGeolocationData('current_location');
  Location.setSearchLocCookie(locationData);
  storeLocationData(locationData);
  setSiteCookies({
    division: division
  });
  delete place.closestDivision;
  return redirectToUrl(getSearchUrl(division, place));
};


/**
 * LS-750 and LS-765
 * Returns link if query matches location override config
 *
 * @param   {String}      query   - User query
 * @param   {String}      address - Address
 * @returns {Null|String} link    - Link for matching query
 */

getGeoSearchOverrideUrl = function(query, address) {
  var i, j, k, len, len1, len2, link, loc, locations, ref1, ref2, searchOverrides, term, terms;
  searchOverrides = ((ref1 = Groupon.LS.data) != null ? ref1.searchOverrides : void 0) || {};
  if (searchOverrides != null) {
    address = normalizeQuery(address != null ? address.toLowerCase().trim() : void 0);
    query = normalizeQuery(query != null ? query.toLowerCase().trim() : void 0);
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref2 = searchOverrides[i], link = ref2.link, terms = ref2.terms, locations = ref2.locations;
      if ((locations != null) && (terms != null)) {
        locations = locations.map(normalizeQuery);
        terms = terms.map(normalizeQuery);
        if (indexOf.call(locations, address) >= 0 && indexOf.call(terms, query) >= 0) {
          return link;
        }
        for (j = 0, len1 = locations.length; j < len1; j++) {
          loc = locations[j];
          for (k = 0, len2 = terms.length; k < len2; k++) {
            term = terms[k];
            if (query === (term + '-' + loc) || query === (loc + '-' + term)) {
              return link;
            }
          }
        }
      }
    }
  }
  return null;
};


/**
 * Returns link if query matches override config
 *
 * @param   {String}                            divisionId - Unique division name
 * @param   {Object} {address, lat, lng, query} attributes
 * @returns {Null|String}                       url        - Link for matching query
 */

getSearchOverrideUrl = function(divisionId, attributes, isMobile2016) {
  var address, key, lat, lng, query, ref1, url, val;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  address = attributes.address, lat = attributes.lat, lng = attributes.lng, query = attributes.query;
  url = findSearchOverridesLink(query, isMobile2016, divisionId);
  if (url == null) {
    return;
  }
  if (url === '/travel') {
    url += '?lat={lat}&lng={lng}&query={query}&address={address}';
  }
  ref1 = {
    address: address,
    lat: lat,
    lng: lng,
    query: query,
    division: divisionId
  };
  for (key in ref1) {
    val = ref1[key];
    url = url.replace('{' + key + '}', val);
  }
  return url.replace(/\s/g, '+');
};


/**
 * Returns link if query matches location override config
 *
 * @param   {Object}      {address} - Attributes
 * @returns {Null|String}           - Link for matching query
 */

getLocationOverrideUrl = function(attributes) {
  var address, i, len, link, locations, overrides, query, ref1, ref2;
  address = attributes.address;
  overrides = ((ref1 = Groupon.LS.data) != null ? ref1.locationOverrides : void 0) || {};
  if (overrides != null) {
    for (i = 0, len = overrides.length; i < len; i++) {
      ref2 = overrides[i], link = ref2.link, locations = ref2.locations;
      if (indexOf.call(locations, address) < 0) {
        continue;
      }
      query = getFormattedQueryString(attributes);
      return link + "?" + query;
    }
  }
  return null;
};

removeGeolocationData = function() {
  return Location.removeGeolocationData('current_location');
};


/**
 * Writes location data to browser's localStorage
 *
 * @param   {Boolean}     setCurrentLocation
 * @param   {Object}      data               - Location data
 * @returns {Null|String}                    - Link for matching query
 */

storeGeolocationData = function(setCurrentLocation, data) {
  if (setCurrentLocation) {
    return Location.setGeolocationData('current_location', data);
  } else {
    return removeGeolocationData();
  }
};

storeLocationData = function(data) {
  var address, lat, lng, locData;
  lat = data.lat, lng = data.lng, address = data.address;
  locData = {
    lat: lat,
    lng: lng,
    address: address
  };
  locData.division = data.division || data.closestDivision;
  return saveRecentSearch(locData, 'location');
};

module.exports = {
  breakDownAddress: breakDownAddress,
  findSearchOverridesLink: findSearchOverridesLink,
  getFormattedQueryString: getFormattedQueryString,
  getGeoSearchOverrideUrl: getGeoSearchOverrideUrl,
  getLocationForSearch: getLocationForSearch,
  getLocationOverrideUrl: getLocationOverrideUrl,
  getSearchOverrideUrl: getSearchOverrideUrl,
  getSearchUrl: getSearchUrl,
  GEO_DATA: GEO_DATA,
  removeGeolocationData: removeGeolocationData,
  storeGeolocationData: storeGeolocationData,
  storeLocationData: storeLocationData,
  saveLocationAndRedirect: saveLocationAndRedirect
};

